__turbopack_context__.v({
  "myBetsTabs": "account-bets-tabs-module-sass-module__pDbrpW__myBetsTabs",
});
